import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import './Anchor.css'


const Anchor = (props) => {
  let to = _.get(props, 'href', _.get(props, 'to', false)),
      {
        size='inherit',
        float=false,
      } = props,
      className = [
        'anchor',
        float !== false ? `float-${float}` : 'none',
        size,
        props.className
      ]

  if (_.get(props, 'to', false) !== false) {
    return (
      <Link
        { ...props }
        className={classNames(className)}
        to={ to }
      >
        { props.children }
      </Link>
    )
  }
  return (
    <a
      href='/'
      { ...props }
      className={classNames(className)}
      onClick={ (e) => {
        if (_.isFunction(props.onClick)) {
          e.preventDefault()
          props.onClick(e)
        }
      } }
    >
      { props.children }
    </a>
  )
}

export default Anchor
